import {
    ImageEffectType,
    OpenAIQuality,
    OpenAISize,
    OpenAIBackground
} from '@/typings/customilyElements/imageEffectType';
import { ImageEffectPreset } from '../types/presets';

export interface OpenAIOption {
    value: OpenAIQuality | OpenAISize | OpenAIBackground;
    label: string;
}

export const OPENAI_QUALITY_OPTIONS: OpenAIOption[] = [
    { value: OpenAIQuality.HIGH, label: 'High' },
    { value: OpenAIQuality.MEDIUM, label: 'Medium' },
    { value: OpenAIQuality.LOW, label: 'Low' },
    { value: OpenAIQuality.AUTO, label: 'Auto' }
];

export const OPENAI_BACKGROUND_OPTIONS: OpenAIOption[] = [
    { value: OpenAIBackground.TRANSPARENT, label: 'Transparent' },
    { value: OpenAIBackground.OPAQUE, label: 'Opaque' },
    { value: OpenAIBackground.AUTO, label: 'Auto' }
];

export const OPENAI_SIZE_OPTIONS: OpenAIOption[] = [
    { value: OpenAISize.SQUARE, label: 'Square (1024x1024)' },
    { value: OpenAISize.LANDSCAPE, label: 'Landscape (1536x1024)' },
    { value: OpenAISize.PORTRAIT, label: 'Portrait (1024x1536)' },
    { value: OpenAISize.AUTO, label: 'Auto' }
];

export const createEffectFromPreset = (preset: ImageEffectPreset): ImageEffectType => {
    const baseConfig = { ...preset.effectConfig };

    if (!baseConfig.id || baseConfig.id === preset.id) {
        baseConfig.id = crypto.randomUUID();
    }

    return baseConfig;
};
